export default "https://cdn-static.gokick.com/assets/e21cd8011b9b3a74c4cd288f1b94a870d12ac47c/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";